import React from 'react';

import { BrandDetail } from 'components/blocks/Brand';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <BrandDetail />
    </div>
  );
};

export default DetailScreen;
